/* src/components/pages/Enrolados.jsx - Modificado el 29-01-2026 */
/* -------------------- tabla de enrolados --------------------- */

import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Button, TextField, Box, Typography, Tooltip, Divider,
  MenuItem, Stack, Dialog, DialogTitle, DialogActions, DialogContent,
  Checkbox, FormControl, FormControlLabel, InputLabel, Select,
  FormHelperText, CircularProgress, Card, Collapse } from '@mui/material';

import api from '../../services/api.js'; // Api Interceptor en vez de Axios

import { DataGrid } from "@mui/x-data-grid";
import { esES } from "@mui/x-data-grid/locales";
import { CustomToolbar } from "../../components/datagrid/CustomToolbar";
import DataGridSkeleton from "../../components/datagrid/DataGridSkeleton";

import { exportPdfAsync, downloadBlob } from "../utils/exportUtils";
import { normalizeRut } from "../utils/rutUtils";
import { validarRut } from "../utils/rutValidator";

import { RiFolderDownloadLine, RiShareBoxFill, RiFileEditLine,
         RiDeleteBin6Line, RiReplyAllFill, RiSave3Fill } from "react-icons/ri";

import { useAuth } from "../../context/AuthContext"; // token

import { useFeedback } from '../../context/FeedbackContext'; // Mensajes breves

/* Campos para exportar a Csv desde el backend */
const CSV_FIELDS = [
  { key: 'fecing_enr', label: 'Fecha' },
  { key: 'rut_enr', label: 'RUT' },
  { key: 'nombre_enr', label: 'Razón Social' },
  { key: 'direccion_enr', label: 'Dirección' },
  { key: 'comuna_enr', label: 'Comuna' },
  { key: 'ciudad_enr', label: 'Ciudad' },
  { key: 'telefono_enr', label: 'Teléfono' },
  { key: 'email_enr', label: 'email' },
  { key: 'nomban1', label: 'Banco 1' },
  { key: 'ctacte1_enr', label: 'Ctacte 1' },
  { key: 'nomban2', label: 'Banco 2' },
  { key: 'ctacte2_enr', label: 'Ctacte 2' },
  { key: 'nomban3', label: 'Banco 3' },
  { key: 'ctacte3_enr', label: 'Ctacte 3' },
];

const Enrolados = ({ modo }) => {
  const { user } = useAuth();

  const [enrolados, setEnrolados] = useState([]);
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [editingEnrolado, setEditingEnrolado] = useState(null);
  const [errors, setErrors] = useState({});
  const rutInputRef = useRef(null); // 👉 referencia al campo Rut
  const nombreInputRef = useRef(null); // 👉 referencia al campo Nombre
  const [acceptedProvee, setAcceptedProvee] = useState(false);

  const [id, setId] = useState(0);
  const [rutEnr, setRutEnr] = useState('');
  const [nombreEnr, setNombreEnr] = useState('');
  const [direccionEnr, setDireccionEnr] = useState('');
  const [comunaEnr, setComunaEnr] = useState('');
  const [ciudadEnr, setCiudadEnr] = useState('');
  const [telefonoEnr, setTelefonoEnr] = useState('');
  const [emailEnr, setEmailEnr] = useState('');
  const [clavesiiEnr, setClavesiiEnr] = useState('');
  const [claveunicaEnr, setClaveunicaEnr] = useState('');
  const [banco1Enr, setBanco1Enr] = useState('');
  const [banco2Enr, setBanco2Enr] = useState('');
  const [banco3Enr, setBanco3Enr] = useState('');
  const [ctacte1Enr, setCtacte1Enr] = useState('');
  const [ctacte2Enr, setCtacte2Enr] = useState('');
  const [ctacte3Enr, setCtacte3Enr] = useState('');

  const [deleteTarget, setDeleteTarget] = useState(null);

  const [bancos, setBancos] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);

  const [generandoPdf, setGenerandoPdf] = useState(false);

  const [openCsvDialog, setOpenCsvDialog] = useState(false);

  /* Selecciona todos los campos para Csv */
  const [selectedCsvFields, setSelectedCsvFields] = useState(
    CSV_FIELDS.map(f => f.key)
  );

  /* Estados para paginación desde el servidor */
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [rowCount, setRowCount] = useState(0);
  
  /* Dialogo y confirmación */
  const { showFeedback } = useFeedback(); // Mensajes breves no bloqueantes

  /* Esconder claves */
  const [showClaves, setShowClaves] = useState(false);
  
  const bancosState = [
    { value: banco1Enr, error: errors.banco1Enr, name: 'banco1Enr', label: 'Banco-1' },
    { value: banco2Enr, error: errors.banco2Enr, name: 'banco2Enr', label: 'Banco-2' },
    { value: banco3Enr, error: errors.banco3Enr, name: 'banco3Enr', label: 'Banco-3' },
  ];

  const cuentasState = [
    { value: ctacte1Enr, error: errors.ctacte1Enr, name: 'ctacte1Enr', label: 'Ctacte-1' },
    { value: ctacte2Enr, error: errors.ctacte2Enr, name: 'ctacte2Enr', label: 'Ctacte-2' },
    { value: ctacte3Enr, error: errors.ctacte3Enr, name: 'ctacte3Enr', label: 'Ctacte-3' },
  ];

  /* Función para cancelar y limpiar los arreglos */
  const handleCancel = () => {
    fetchEnrolados({ page, pageSize });
   };

   /* Validación de formato de email */
  const validarEmail = (email) => {
    // Expresión regular para validar el formato del email
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  /* Cargar todos los registros de la tabla enrolados */
  const fetchEnrolados = useCallback(
    async ({ page, pageSize }) => {
      try {
        if (!user.usuario) {
          showFeedback({
            message: 'Debe ingresar el Rut',
            severity: 'warning',
          });
          return;
        }

        setLoading(true);

        const RutCli = normalizeRut(user.usuario);

        const { data } = await api.post('/enrolados/getenrolados', {
          RutCli,
          page,
          pageSize,
        });

        if (data.success) {
          setEnrolados(data.rows);
          setRowCount(data.total);
        } else {
          setEnrolados([]);
          setRowCount(0);
        }
      } catch (error) {
        setEnrolados([]);
        setRowCount(0);

        showFeedback({
          message: 'No fue posible obtener los enrolados, intente más tarde.',
          severity: 'error',
        });
      } finally {
        setLoading(false);
      }
    },
    [user.usuario, showFeedback]
  );

  /* cargar bancos desde tabla bancos */
  const fetchBancos = useCallback(async () => {
    try {
      const response = await api.post('/registrarse/getbancos', {
        idBan: 0
      });
      if (response.data.success && response.data.rows) {
        setBancos(response.data.rows);
      } else {
        setBancos([]);
      }

    } catch (error) {
      setBancos([]);
    }
  }, []);

  /* cargar los bancos */
  useEffect(() => {
    fetchBancos();
  }, [fetchBancos]);

  /* cargar enrolados */
  useEffect(() => {
    if (!user.usuario) return;

    fetchEnrolados({
      page,
      pageSize,
    });
  }, [user.usuario, page, pageSize, fetchEnrolados]);

  /* Validar bancos y ctasctes */
  const validateBankPair = (banco, cuenta, idx, newErrors) => {
    const bancoKey = `banco${idx}Enr`;
    const cuentaKey = `ctacte${idx}Enr`;

    newErrors[bancoKey] = '';
    newErrors[cuentaKey] = '';

    const cuentaValida = cuenta && cuenta.trim() !== '';
    const bancoValido = banco && banco.trim() !== '';

    if (bancoValido && !cuentaValida) {
      newErrors[cuentaKey] = `Debe ingresar la Ctacte ${idx}`;
    }
    if (!bancoValido && cuentaValida) {
      newErrors[bancoKey] = `Debe seleccionar el Banco ${idx}`;
    }
  };

  /* control para los input */
  const handleInputChange = async (e, fieldName) => {
    const { value } = e.target;
    let newErrors = { ...errors };

    switch (fieldName) {
      case 'rutEnr':
        setRutEnr(value);
        newErrors.rutEnr = '';

        if (!value.trim()) {
          newErrors.rutEnr = '';
          break;
        }

        if (!validarRut(value)) newErrors.rutEnr = 'El Rut ingresado no es válido';
        else {
          try {
            const fixRutCli = normalizeRut(user.usuario);
            const fixRutEnr = value.padStart(10, '0');
            const rutEnrExists = await checkrutEnrExists(fixRutCli, fixRutEnr);
            if (rutEnrExists){
              showFeedback({
                message: 'El Rut ingresado ya existe.',
                severity: 'warning',
              });
            }
          } catch {
            showFeedback({
              message: 'Hubo un problema al verificar el RUT',
              severity: 'warning',
            });
          }
        }
        break;

      case 'nombreEnr':
        setNombreEnr(value);
        newErrors.nombreEnr = value.trim() === '' ? 'Debe ingresar el nombre' : '';
        break;

      case 'direccionEnr':
        setDireccionEnr(value);
        newErrors.direccionEnr = value.trim() === '' ? 'Debe ingresar la dirección' : '';
        break;

      case 'comunaEnr':
        setComunaEnr(value);
        newErrors.comunaEnr = value.trim() === '' ? 'Debe ingresar la comuna' : '';
        break;

      case 'ciudadEnr':
        setCiudadEnr(value);
        newErrors.ciudadEnr = value.trim() === '' ? 'Debe ingresar la ciudad' : '';
        break;

      case 'telefonoEnr':
        setTelefonoEnr(value);
        newErrors.telefonoEnr = value.trim() === '' ? 'Debe ingresar el teléfono' : '';
        break;

      case 'emailEnr':
        setEmailEnr(value);
        newErrors.emailEnr =
          value.trim() === '' || !validarEmail(value) ? 'El email ingresado no es válido' : '';
        break;

      case 'clavesiiEnr':
        setClavesiiEnr(value);
        newErrors.clavesiiEnr = value.trim() === '' ? 'Debe ingresar la clave del SII' : '';
        break;

      case 'claveunicaEnr':
        setClaveunicaEnr(value);
        newErrors.claveunicaEnr = '';
        break;

      /* ---------- Bancos y Ctacte ---------- */
      case 'banco1Enr':
        setBanco1Enr(value);
        break;
      case 'ctacte1Enr':
        setCtacte1Enr(value);
        break;
      case 'banco2Enr':
        setBanco2Enr(value);
        break;
      case 'ctacte2Enr':
        setCtacte2Enr(value);
        break;
      case 'banco3Enr':
        setBanco3Enr(value);
        break;
      case 'ctacte3Enr':
        setCtacte3Enr(value);
        break;

      default:
        break;
    }

    /* Validación bancos/cuentas con valores actualizados */
    validateBankPair(
      fieldName === 'banco1Enr' ? value : banco1Enr,
      fieldName === 'ctacte1Enr' ? value : ctacte1Enr,
      1,
      newErrors
    );

    validateBankPair(
      fieldName === 'banco2Enr' ? value : banco2Enr,
      fieldName === 'ctacte2Enr' ? value : ctacte2Enr,
      2,
      newErrors
    );

    validateBankPair(
      fieldName === 'banco3Enr' ? value : banco3Enr,
      fieldName === 'ctacte3Enr' ? value : ctacte3Enr,
      3,
      newErrors
    );

    /* Validación global */
    const hasErrors = Object.values(newErrors).some(err => err && err !== '');
    const requiredFields = [
      rutEnr,
      fieldName === 'nombreEnr' ? value : nombreEnr,
      fieldName === 'direccionEnr' ? value : direccionEnr,
      fieldName === 'comunaEnr' ? value : comunaEnr,
      fieldName === 'ciudadEnr' ? value : ciudadEnr,
      telefonoEnr,
      emailEnr,
      fieldName === 'clavesiiEnr' ? value : clavesiiEnr
    ];
    const hasEmptyFields = requiredFields.some(field => !field || field.trim() === '');

    setErrors(newErrors);
    setIsFormValid(!hasErrors && !hasEmptyFields);
  }

  /* Verificar si el rut del cliente + asociado o enrolado ya existe en la bd */
  const checkrutEnrExists = async (fixrutCli, fixrutEnr) => {
    try {
      const data = await api.post('/registrarse/checkrutEnr', {
        RutCli: fixrutCli,
        RutEnr: fixrutEnr
      });

      return data.data.success;

    } catch (error) {
      return false;
    }
  };

  /*-------------------------------------------------------*/
  /* Verificar si el Rut del enrolado + el Rut del Cliente */
  /* ya existe en la base de datos                         */
  /*-------------------------------------------------------*/
  const checkRutExists = async (fixrutEnr) => {
    try {
      // Usamos rut desde el estado (cliente autenticado)
      const rutCli = normalizeRut(user.usuario);
      // Usamos el rut ingresado en pantalla
      const rutEnr = fixrutEnr.padStart(10, '0');       

      const data = await api.post('/enrolados/checkrut', {
        rutCli, rutEnr
      });

      return data.data.success;

    } catch (error) {
      return false; // Si hubo un error, retornar false //
    }
  };

  /* Agregar o Editar Enrolado */
  const handleSave = async () => {
    const validationErrors = {};

    if (!rutEnr) validationErrors.rutEnr = 'El Rut es obligatorio';
    if (!nombreEnr) validationErrors.nombreEnr = 'El Nombre es obligatorio';
    if (!direccionEnr) validationErrors.direccionEnr = 'La Dirección es obligatoria';
    if (!comunaEnr) validationErrors.comunaEnr = 'La Comuna es obligatoria';
    if (!ciudadEnr) validationErrors.ciudadEnr = 'La Ciudad es obligatoria';
    if (!telefonoEnr) validationErrors.telefonoEnr = 'El Teléfono es obligatorio';
    if (!emailEnr) validationErrors.emailEnr = 'El Email es obligatorio';

    if (banco1Enr && !ctacte1Enr) validationErrors.ctacte1Enr = 'Debe ingresar Ctacte 1';
    if (ctacte1Enr && !banco1Enr) validationErrors.banco1Enr = 'Debe seleccionar el Banco 1';

    if (banco2Enr && !ctacte2Enr) validationErrors.ctacte2Enr = 'Debe ingresar Ctacte 2';
    if (ctacte2Enr && !banco2Enr) validationErrors.banco2Enr = 'Debe seleccionar el Banco 2';

    if (banco3Enr && !ctacte3Enr) validationErrors.ctacte3Enr = 'Debe ingresar Ctacte 3';
    if (ctacte3Enr && !banco3Enr) validationErrors.banco3Enr = 'Debe seleccionar el Banco 3';

    /* Validación de formato de email */
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailEnr && !emailRegex.test(emailEnr)) {
      validationErrors.emailEnr = 'El Email no es válido';
    }
    
    if (!validarRut(rutEnr)) {
      validationErrors.rutEnr = 'El Rut no es válido';
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    /* Normalizar datos */
    const fixrutEnr = normalizeRut(rutEnr);

    const uppernombreEnr = nombreEnr.toUpperCase();
    const upperdireccionEnr = direccionEnr.toUpperCase();
    const uppercomunaEnr = comunaEnr.toUpperCase();
    const upperciudadEnr = ciudadEnr.toUpperCase();
    const loweremailEnr = emailEnr.toLowerCase();

    
    /* Update del registro */
    try {
      if (editingEnrolado) {
        await api.post('/enrolados/updateenrolado', {
          rut: user.usuario,
          id_enr: id,
          rut_enr: fixrutEnr,
          nombre_enr: uppernombreEnr,
          direccion_enr: upperdireccionEnr,
          comuna_enr: uppercomunaEnr,
          ciudad_enr: upperciudadEnr,
          telefono_enr: telefonoEnr,
          email_enr: loweremailEnr,
          clavesii_enr: clavesiiEnr,
          claveunica_enr: claveunicaEnr,
          banco1_enr: banco1Enr ? Number(banco1Enr) : null,
          ctacte1_enr: ctacte1Enr,
          banco2_enr: banco2Enr ? Number(banco2Enr) : null,
          ctacte2_enr: ctacte2Enr,
          banco3_enr: banco3Enr ? Number(banco3Enr) : null,
          ctacte3_enr: ctacte3Enr,
          proveedor_enr: acceptedProvee,
        });
        showFeedback({
          message: 'El cliente fue actualizado correctamente.',
          severity: 'success',
        });

      /* Insert registro */
      } else {
        /* Verificar si el RUT ya existe en la base de datos */
        const rutExists = await checkRutExists(fixrutEnr);

        /* Revisar si el campo success en la respuesta es true */
        if (rutExists) {
          /* Si el servidor responde que la validacion no fue exitosa */
          showFeedback({
            message: 'El Enrolado Ya Existe.',
            severity: 'warning',
          });
          setErrors({});
          return;
        }

        await api.post('/enrolados/addenrolado', {
          rut: user.usuario,
          rut_enr: fixrutEnr,
          nombre_enr: uppernombreEnr,
          direccion_enr: upperdireccionEnr,
          comuna_enr: uppercomunaEnr,
          ciudad_enr: upperciudadEnr,
          telefono_enr: telefonoEnr,
          email_enr: loweremailEnr,
          clavesii_enr: clavesiiEnr,
          claveunica_enr: claveunicaEnr,
          banco1_enr: banco1Enr ? Number(banco1Enr) : null,
          ctacte1_enr: ctacte1Enr,
          banco2_enr: banco2Enr ? Number(banco2Enr) : null,
          ctacte2_enr: ctacte2Enr,
          banco3_enr: banco3Enr ? Number(banco3Enr) : null,
          ctacte3_enr: ctacte3Enr,
          proveedor_enr: acceptedProvee,
        });
        showFeedback({
          message: 'El cliente fue agregado correctamente.',
          severity: 'success',
        });
      }
      fetchEnrolados({ page, pageSize });
      handleCloseModal();

    } catch (error) {
      showFeedback({
        message: 'Hubo un problema al procesar la solicitud, intente más tarde',
        severity: 'error',
      });
    }
  };

  /* Eliminar registro */
  const handleDelete = async (enrolado) => {
    try {

      await api.post('/enrolados/deleteenrolado', {
        id_enr: enrolado.id_enr,
        rutCli: user.usuario,
        rutEnr: enrolado.rut_enr,
      });

      showFeedback({
        message: 'El registro ha sido eliminado correctamente.',
        severity: 'info',
      });

      fetchEnrolados({ page, pageSize });
      
    } catch (error) {
      showFeedback({
        message: 'Hubo un problema al procesar la solicitud, intente más tarde',
        severity: 'error',
      });
    }
  };
  
  /* Abrir Modal para Editar Enrolado */
  const handleEdit = (enrolado) => {
    setId(enrolado.id_enr);
    setRutEnr(enrolado.rut_enr);
    setNombreEnr(enrolado.nombre_enr);
    setDireccionEnr(enrolado.direccion_enr);
    setComunaEnr(enrolado.comuna_enr);
    setCiudadEnr(enrolado.ciudad_enr);
    setTelefonoEnr(enrolado.telefono_enr);
    setEmailEnr(enrolado.email_enr);
    setClavesiiEnr(enrolado.clavesii_enr);
    setClaveunicaEnr(enrolado.claveunica_enr);
    setBanco1Enr(enrolado.banco1_enr ? String(enrolado.banco1_enr) : '');
    setBanco2Enr(enrolado.banco2_enr ? String(enrolado.banco2_enr) : '');
    setBanco3Enr(enrolado.banco3_enr ? String(enrolado.banco3_enr) : '');
    setCtacte1Enr(enrolado.ctacte1_enr);
    setCtacte2Enr(enrolado.ctacte2_enr);
    setCtacte3Enr(enrolado.ctacte3_enr);
    setAcceptedProvee(enrolado.proveedor_enr);
    setEditingEnrolado(enrolado);
    setIsFormValid(false);
    setShowClaves(false);
    setOpen(true);

    /* Limpiar el error de todos los input */
    setErrors({});
  };

  useEffect(() => {
    if (open && editingEnrolado) {
      const requiredFields = [
        rutEnr,
        nombreEnr,
        direccionEnr,
        comunaEnr,
        ciudadEnr,
        telefonoEnr,
        emailEnr,
      ];

      const hasEmptyFields = requiredFields.some(
        (field) => !field || field.trim() === ''
      );

      const hasErrors = Object.values(errors).some(
        (err) => err && err !== ''
      );

      setIsFormValid(!hasEmptyFields && !hasErrors);
    }
  }, [
    open,
    editingEnrolado,
    rutEnr,
    nombreEnr,
    direccionEnr,
    comunaEnr,
    ciudadEnr,
    telefonoEnr,
    emailEnr,
    errors,
  ]);

  /* Abrir Modal para Crear Enrolado */
  const handleAdd = () => {
    setRutEnr('');
    setNombreEnr('');
    setDireccionEnr('');
    setComunaEnr('');
    setCiudadEnr('');
    setTelefonoEnr('');
    setEmailEnr('');
    setClavesiiEnr('');
    setClaveunicaEnr('');
    setBanco1Enr('');
    setCtacte1Enr('');
    setBanco2Enr('');
    setCtacte2Enr('');
    setBanco3Enr('');
    setCtacte3Enr('');
    setEditingEnrolado(null);
    setAcceptedProvee(false);
    setIsFormValid(false);
    setShowClaves(false);
    setOpen(true);

    /* Limpiar el error de todos los input */
    setErrors({});
  };

  /* Estado para cerrar el modal */
  const handleCloseModal = () => {
    setOpen(false);
  };

  /* 👉 al abrir modal, enfocar en RUT */
  useEffect(() => {
    if (open) {
      /* Esperar al siguiente ciclo del render para asegurar que los inputs existan */
      const timer = setTimeout(() => {
        if (editingEnrolado) {
          /* En edición → enfocar NOMBRE */
          if (nombreInputRef.current) nombreInputRef.current.focus();
        } else {
          /* En nuevo registro → enfocar RUT */
          if (rutInputRef.current) rutInputRef.current.focus();
        }
      }, 100); // 100 ms asegura que el modal ya esté montado

      /* Limpieza al desmontar */
      return () => clearTimeout(timer);
    }
  }, [open, editingEnrolado]);



  /* exportar a pdf todos los datos de la tabla */
  const exportToPDF = async () => {
    exportPdfAsync({
      endpointBase: "/enrolados/pdf",
      payload: {
        RutCli: normalizeRut(user.usuario),
        RutEnr: '',
        Tipousr: 1, /* cliente */
      },
      onStart: () => setGenerandoPdf(true),
      onFinish: () => setGenerandoPdf(false),
      onError: (msg) => {
        setGenerandoPdf(false);
        showFeedback({
          message: msg,
          severity: "error",
        });
      },
    });
  };

  /* Helpers de Selección de campos para exportar a Csv */
  const toggleCsvField = (fieldKey) => {
    setSelectedCsvFields(prev =>
      prev.includes(fieldKey)
        ? prev.filter(k => k !== fieldKey)
        : [...prev, fieldKey]
    );
  };

  /* Configuración de MUI DataGrid */
  const columns = [
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 90,
      sortable: false,
      filterable: false,
      align: 'center',
      renderCell: ({ row }) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* Editar */}
          <Tooltip title="Editar" placement="top" arrow>
            <Button
              onClick={() => handleEdit(row)}
              variant="contained"
              size="small"
              sx={{
                backgroundColor: (theme) => theme.custom.ui.primaryAction,
                color: (theme) => theme.custom.ui.primaryActionText,
                minWidth: 0,
                padding: 0,
                width: 30,
                height: 22,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',

                '&:hover': {
                  backgroundColor: (theme) =>
                    theme.custom.ui.primaryActionHover,
                },
              }}
            >
              <RiFileEditLine size={18} />
            </Button>
          </Tooltip>

          {/* Eliminar */}
          <Tooltip title="Eliminar" placement="top" arrow>
            <Button
              onClick={() => setDeleteTarget(row)}
              variant="contained"
              size="small"
              sx={{
                backgroundColor: (theme) => theme.custom.ui.dangerBg,
                color: (theme) => theme.custom.ui.dangerText,
                minWidth: 0,
                padding: 0,
                width: 30,
                height: 22,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',

                '&:hover': {
                  backgroundColor: (theme) =>
                    theme.custom.ui.dangerBgHover,
                },
              }}
            >
              <RiDeleteBin6Line size={18} />
            </Button>
          </Tooltip>
        </div>
      )
    },
    {
      field: 'id_enr',
      width: 80,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Id del Registro" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Id
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'rut_enr',
      headerName: "Rut",
      width: 130,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Rut del Enrolado" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Rut
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'nombre_enr',
      headerName: "Nombre",
      width: 300,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Nombre del Enrolado" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Nombre
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'direccion_enr',
      headerName: "Dirección",
      width: 300,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Dirección del Enrolado" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Dirección
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'comuna_enr',
      headerName: "Comuna",
      width: 150,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Comuna del Enrolado" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Comuna
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'ciudad_enr',
      headerName: "Ciudad",
      width: 150,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Ciudad del Enrolado" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Ciudad
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'telefono_enr',
      headerName: "Teléfono",
      width: 200,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Teléfono del Enrolado" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Teléfono
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'email_enr',
      headerName: "Email",
      width: 300,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Email del Enrolado" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Email
          </span>
        </Tooltip>
      ),
    },
  ];

  /* Llama a crear Csv */
  const handleExportCsv = async () => {
    try {
      const RutCli = normalizeRut(user.usuario);

      const response = await api.post('/enrolados/csv',
        {
          RutCli,
          fields: selectedCsvFields,
        },
        {
          responseType: 'blob',
        }
      );

      downloadBlob(response.data, "enrolados.csv");
      setOpenCsvDialog(false);

    } catch (error) {
      showFeedback({
        message: 'No fue posible exportar el CSV',
        severity: 'error',
      });
    }
  };

  /* Render */
  return (
    <Box sx={{ width: '100%', pt: 0, overflow: 'visible' }}>
      {/* Barra de Controles */}
      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        flexWrap="wrap"
        alignItems="center"
        sx={{
          mb: 1,
          flexShrink: 0,       // 👈 NO se colapsa
        }}
      >
        <TextField
          label="Rut"
          value={user?.usuario || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: { shrink: true },
          }}
          sx={{
            minWidth: 140,
            flexShrink: 0,
            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
              textAlign: 'center',
              letterSpacing: '0.03em',
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        <TextField
          label="Cliente"
          value={user?.nombre || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          sx={{
            minWidth: 260,
            flexGrow: 1,
            flexShrink: 0,

            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        {/* Botón Agregar */}
        <Button variant="contained"
          onClick={handleAdd}
          sx={{
            minWidth: 110,
            height: 40,
            flexShrink: 0,

            backgroundColor: (theme) => theme.custom.ui.primaryAction,
            color: (theme) => theme.custom.ui.primaryActionText,

            '&:hover': {
              backgroundColor: (theme) => theme.custom.ui.primaryActionHover,
            },
          }}
        >
          Agregar
        </Button>

        {/* Botón Cancelar */}
        <Button
          variant="contained"
          onClick={handleCancel}
          sx={{
            minWidth: 110,
            height: 40,
            flexShrink: 0,

            backgroundColor: (theme) => theme.custom.ui.primaryAction,
            color: (theme) => theme.custom.ui.primaryActionText,

            '&:hover': {
              backgroundColor: (theme) => theme.custom.ui.primaryActionHover,
            },
          }}
        >
          Cancelar
        </Button>

        {/* Botón Exportar a Pdf */}
        <Button
          variant="contained"
          startIcon={<RiFolderDownloadLine size={18} />}
          disabled={enrolados.length === 0}
          onClick={exportToPDF}
          sx={{
            minWidth: 110,
            height: 40,
            flexShrink: 0,
            backgroundColor: (theme) => theme.custom.ui.exportActionBg,
            color: (theme) => theme.custom.ui.exportActionText,
            border: (theme) =>
              `1px solid ${theme.custom.ui.exportActionBorder}`,

            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.exportActionBgHover,
            },
          }}
        >
          PDF
        </Button>

        {/* Botón Exportar a Csv */}
        <Button
          variant="contained"
          startIcon={<RiShareBoxFill size={18} />}
          disabled={enrolados.length === 0}
          onClick={() => setOpenCsvDialog(true)}
          sx={{
            minWidth: 110,
            height: 40,
            backgroundColor: (theme) => theme.custom.ui.exportActionBg,
            color: (theme) => theme.custom.ui.exportActionText,
            border: (theme) =>
              `1px solid ${theme.custom.ui.exportActionBorder}`,

            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.exportActionBgHover,
            },
          }}
        >
          CSV
        </Button>
      </Stack>


      {/* Configuración MIU DataGrid */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 210px)', // ajusta según tu layout
          minHeight: 0,
        }}
       >
        <DataGrid
          rows={enrolados}
          columns={columns}
          getRowId={(row) => row.id_enr}
          loading={loading}

          paginationMode="server"
          rowCount={rowCount}
          pageSizeOptions={[10, 20, 50, 100]}
          paginationModel={{ page, pageSize }}

          onPaginationModelChange={({ page, pageSize }) => {
            setPage(page);
            setPageSize(pageSize);
          }}

          density="compact"
          rowHeight={38}
          headerHeight={40}
          disableRowSelectionOnClick

          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          slots={{
            toolbar: CustomToolbar,
            loadingOverlay: DataGridSkeleton,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 400 },
            },
          }}
          sx={{
            height: '100%',
            border: 'none',
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
      </Box>

      <Typography variant="caption" color="text.secondary">
        {rowCount.toLocaleString('es-CL')} registros encontrados
      </Typography>

      {/* Dialogo generando pdf */}
      <Dialog
        open={generandoPdf}
        aria-labelledby="generando-pdf-title"
        aria-describedby="generando-pdf-desc"

        maxWidth="xs"
        fullWidth
        slotProps={{
          paper: {
            sx: (theme) => ({
              borderRadius: 3,
              textAlign: 'center',
              backgroundColor: theme.custom.ui.modalBg,
              boxShadow: theme.custom.ui.modalShadow,
            }),
          },
        }}
      >
        <DialogContent>
          <Stack spacing={2} alignItems="center" py={2}>
            <CircularProgress
              size={42}
              thickness={4}
              sx={{
                color: (theme) => theme.custom.ui.focus,
              }}
            />

            <Typography id="generando-pdf-title" variant="body2">
              Generando reporte
            </Typography>

            <Typography
              id="generando-pdf-desc"
              variant="caption"
              color="text.secondary"
            >
              Estamos trabajando en ello…
            </Typography>
          </Stack>
        </DialogContent>
      </Dialog>

      {/* Dialogo selección de campos para Csv desde el backend */}
      <Dialog
        open={openCsvDialog}
        onClose={() => setOpenCsvDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Box
            sx={{
              mb: 0,
              color: (theme) => theme.custom.ui.brandAccent,
              fontSize: '1.4rem'
            }}>
            Exportar CSV
          </Box>
        </DialogTitle>

        <Divider />

        <DialogContent>
          <Box sx={{ mb: 1, color: 'text.secondary', fontSize: '0.85rem' }}>
            Selecciona los campos que deseas incluir en el archivo.
          </Box>

          <Stack spacing={0.5}>
            {CSV_FIELDS.map(field => (
              <FormControlLabel
                key={field.key}
                control={
                  <Checkbox
                    checked={selectedCsvFields.includes(field.key)}
                    onChange={() => toggleCsvField(field.key)}
                  />
                }
                label={field.label}
              />
            ))}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenCsvDialog(false)}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.secondaryActionBg,
              color: (theme) => theme.custom.ui.secondaryActionText,
              '&:hover': {
                backgroundColor: (theme) => theme.custom.ui.secondaryActionBgHover,
              },
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="contained"
            disabled={selectedCsvFields.length === 0}
            onClick={handleExportCsv}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.primaryAction,
              color: (theme) => theme.custom.ui.primaryActionText,
              '&:hover': {
                backgroundColor: (theme) => theme.custom.ui.primaryActionHover,
              },
            }}
          >
            Exportar
          </Button>

        </DialogActions>
      </Dialog>


      {/* Modal para ingresar o modificar */}
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleCloseModal();
          }
        }}
        disableEnforceFocus
        disableRestoreFocus
        fullWidth={false}
        maxWidth={false} // 👈 control total del ancho
      >
        <Card
          sx={{
            width: {
              xs: '95vw',
              sm: '90vw',
              md: '82vw',
              lg: 900,
            },
            maxWidth: 960,

            height: '85vh',
            display: 'flex',
            flexDirection: 'column',

            borderRadius: 4,
            border: (theme) => `1px solid ${theme.custom.ui.borderSubtle}`,
            boxShadow: (theme) => theme.custom.ui.modalShadow,
            overflow: 'hidden',
          }}
        >
          {/* ================= HEADER ================= */}
          <Box px={3} pt={1} pb={1}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="h6" fontWeight={600} lineHeight={1.2}>
                  {editingEnrolado ? 'Editar Enrolado' : 'Nuevo Enrolado'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Información general y bancaria
                </Typography>
              </Box>

              <Typography variant="caption" color="text.secondary">
                ▶️ Overwatch
              </Typography>
            </Stack>
          </Box>

          <Divider />

          {/* ================= CONTENIDO (SCROLL) ================= */}
          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              overflowX: 'hidden',
              px: 3,
              py: 2,
            }}
          >
            {/* ================= DATOS PERSONALES ================= */}
            <Box mb={2}>
              <Typography
                variant="subtitle2"
                fontWeight={600}
                mb={1}
                sx={sectionTitleSx}
              >
                Datos del enrolado
              </Typography>

              <Stack spacing={2}>
                <TextField
                  label="Rut"
                  value={rutEnr}
                  onChange={(e) => handleInputChange(e, 'rutEnr')}
                  inputRef={rutInputRef}
                  disabled={Boolean(editingEnrolado)}
                  sx={{
                    ...fieldSx,
                    width: { xs: '100%', sm: '20%' },
                    '& .MuiInputBase-input.Mui-disabled': {
                      textAlign: 'center',
                      letterSpacing: '0.03em',
                    },
                  }}
                  error={Boolean(errors.rutEnr)}
                  helperText={errors.rutEnr}
                />

                <TextField
                  label="Nombre"
                  value={nombreEnr}
                  onChange={(e) => handleInputChange(e, 'nombreEnr')}
                  inputRef={nombreInputRef}
                  fullWidth
                  sx={fieldSx}
                  error={Boolean(errors.nombreEnr)}
                  helperText={errors.nombreEnr}
                />
              </Stack>
            </Box>

            {/* ================= UBICACIÓN ================= */}
            <Box mb={2}>
              <Typography
                variant="subtitle2"
                fontWeight={600}
                mb={1}
                sx={sectionTitleSx}
              >
                Ubicación
              </Typography>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  label="Dirección"
                  value={direccionEnr}
                  onChange={(e) => handleInputChange(e, 'direccionEnr')}
                  fullWidth
                  sx={fieldSx}
                  error={Boolean(errors.direccionEnr)}
                  helperText={errors.direccionEnr}
                />

                <TextField
                  label="Comuna"
                  value={comunaEnr}
                  onChange={(e) => handleInputChange(e, 'comunaEnr')}
                  fullWidth
                  sx={fieldSx}
                  error={Boolean(errors.comunaEnr)}
                  helperText={errors.comunaEnr}
                />

                <TextField
                  label="Ciudad"
                  value={ciudadEnr}
                  onChange={(e) => handleInputChange(e, 'ciudadEnr')}
                  fullWidth
                  sx={fieldSx}
                  error={Boolean(errors.ciudadEnr)}
                  helperText={errors.ciudadEnr}
                />
              </Stack>
            </Box>

            {/* ================= CONTACTO ================= */}
            <Box mb={2}>
              <Typography
                variant="subtitle2"
                fontWeight={600}
                mb={1}
                sx={sectionTitleSx}
              >
                Contacto
              </Typography>

              <Stack spacing={2}>
                <TextField
                  label="Teléfono"
                  value={telefonoEnr}
                  onChange={(e) => handleInputChange(e, 'telefonoEnr')}
                  fullWidth
                  sx={fieldSx}
                  error={Boolean(errors.telefonoEnr)}
                  helperText={errors.telefonoEnr}
                />

                <TextField
                  label="Email"
                  value={emailEnr}
                  onChange={(e) => handleInputChange(e, 'emailEnr')}
                  fullWidth
                  sx={fieldSx}
                  error={Boolean(errors.emailEnr)}
                  helperText={errors.emailEnr}
                />
              </Stack>
            </Box>

            {/* ================= CLAVES ================= */}
            <Box mb={2}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
                gap={1}
              >
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  sx={sectionTitleSx}
                >
                  Claves
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Información sensible. Mostrar solo si es necesario.
                </Typography>

                <Button
                  size="small"
                  onClick={() => setShowClaves((prev) => !prev)}
                  sx={{ textTransform: 'none' }}
                >
                  {showClaves ? 'Ocultar claves' : 'Mostrar claves'}
                </Button>
              </Stack>
            </Box>

            <Collapse
              in={showClaves}
              timeout={300}
              easing={{
                enter: 'cubic-bezier(0.4, 0, 0.2, 1)',
                exit: 'cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            >
              <Box mb={2}>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={2}
                >
                  <TextField
                    label="Clave SII"
                    value={clavesiiEnr}
                    onChange={(e) => handleInputChange(e, 'clavesiiEnr')}
                    error={Boolean(errors.clavesiiEnr)}
                    helperText={errors.clavesiiEnr}
                    sx={fieldSx}
                    fullWidth
                  />

                  <TextField
                    label="Clave Única"
                    value={claveunicaEnr}
                    onChange={(e) => handleInputChange(e, 'claveunicaEnr')}
                    error={Boolean(errors.claveunicaEnr)}
                    helperText={errors.claveunicaEnr}
                    sx={fieldSx}
                    fullWidth
                  />
                </Stack>
              </Box>
            </Collapse>

            {/* ================= BANCOS ASOCIADOS ================= */}
            <Box mb={2}>
              <Typography
                variant="subtitle2"
                fontWeight={600}
                mb={1}
                sx={sectionTitleSx}
              >
                Bancos asociados
              </Typography>

              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  {bancosState.map((b) => (
                    <FormControl
                      key={b.name}
                      fullWidth
                      error={Boolean(b.error)}
                      sx={fieldSx}
                    >
                      <InputLabel>{b.label}</InputLabel>
                      <Select
                        value={b.value}
                        label={b.label}
                        onChange={(e) => handleInputChange(e, b.name)}
                        sx={{ height: 40 }}
                      >
                        <MenuItem value="">✨ Seleccionar Banco</MenuItem>
                        {bancos.map((ban) => (
                          <MenuItem key={ban.id} value={String(ban.id)}>
                            {ban.nomban}
                          </MenuItem>
                        ))}
                      </Select>
                      {b.error && <FormHelperText>{b.error}</FormHelperText>}
                    </FormControl>
                  ))}
                </Stack>

                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                  {cuentasState.map((c) => (
                    <TextField
                      key={c.name}
                      label={c.label}
                      value={c.value}
                      onChange={(e) => handleInputChange(e, c.name)}
                      error={Boolean(c.error)}
                      helperText={c.error}
                      sx={fieldSx}
                      fullWidth
                    />
                  ))}
                </Stack>
              </Stack>
            </Box>

            {/* Tambien es proveedor */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={acceptedProvee}
                  onChange={(e) => setAcceptedProvee(e.target.checked)}
                />
              }
              label={
                <Typography variant="subtitle1" >
                  🚚 Registrame como Proveedor
                </Typography>
              }
            />

            {/* ================= FOOTER ================= */}
            <Divider />

            <Box
              sx={{
                px: 3,
                py: 2,
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 1.5,
                backgroundColor: 'inherit',
              }}
            >
              <Button
                variant="outlined"
                onClick={handleCloseModal}
                startIcon={<RiReplyAllFill />}
                sx={(theme) => ({
                  backgroundColor: theme.custom.ui.secondaryActionBg,
                  color: theme.custom.ui.secondaryActionText,
                  borderRadius: 8,
                  padding: '6px 14px',
                  minHeight: 36,
                  border: `1px solid ${theme.custom.ui.secondaryActionBorder}`,

                  '&:hover': {
                    backgroundColor: theme.custom.ui.secondaryActionBgHover,
                    boxShadow:
                      theme.palette.mode === 'dark'
                        ? `inset 0 0 0 1px ${theme.custom.ui.secondaryActionBorderHover}`
                        : theme.custom.ui.surfaceShadow,
                  },
                })}
              >
                Cancelar
              </Button>

              <Button
                variant="contained"
                disabled={!isFormValid}
                onClick={handleSave}
                startIcon={<RiSave3Fill />}
                sx={(theme) => ({
                  backgroundColor: theme.custom.ui.primaryActionBg,
                  color: theme.custom.ui.primaryActionText,
                  borderRadius: 8,
                  padding: '6px 16px',
                  minHeight: 36,

                  boxShadow: theme.custom.ui.primaryActionShadow,

                  '&:hover': {
                    backgroundColor: theme.custom.ui.primaryActionBgHover,
                    boxShadow: theme.custom.ui.primaryActionShadowHover,
                  },
                })}
              >
                {editingEnrolado ? 'Actualizar' : 'Guardar'}
              </Button>
            </Box>
          </Box>
        </Card>
    </Dialog>


    <Dialog open={Boolean(deleteTarget)}>
      <DialogTitle>Confirmar eliminación</DialogTitle>
      <DialogContent>
        ¿Deseas eliminar el enrolado <b>{deleteTarget?.nombre_enr}</b>?
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDeleteTarget(null)}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={() => {
            handleDelete(deleteTarget);
            setDeleteTarget(null);
          }}
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>

    </Box>
  );
};
/* Configuracion ux input */
const fieldSx = {
  '& .MuiInputBase-root': {
    height: 30,
    fontSize: 13.5,
  },
  '& .MuiInputLabel-root': {
    fontSize: 12.5,
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    fontSize: '0.7rem',
    minHeight: '1em',
  },
};

const sectionTitleSx = {
  fontWeight: 600,
  fontSize: '0.9rem',
  letterSpacing: '0.02em',
  color: (theme) => theme.custom.ui.titleAccent,
};

export default Enrolados;
